<template>
    <page-header-wrapper>
        <a-card :bordered="false">
            <!-- 条件搜索 -->
            <!-- <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="48">
                        <a-col :md="!advanced && 8 || 24" :sm="24">
                            <span class="table-page-search-submitButtons"
                                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div> -->
            <!-- 操作 -->
            <div class="table-operations">
                <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
                    :refresh-loading="loading" @refresh="getList" />
            </div>
            <!-- 增加修改 -->
            <create-form ref="createForm" @ok="getList" />
            <!-- 数据展示 -->
            <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
                :bordered="tableBordered">
                <span slot="operation" slot-scope="text, record">
                    <a-divider type="vertical" v-hasPermi="['video:push:edit']" />
                    <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['video:push:edit']">
                        <a-icon type="edit" />修改
                    </a>
                </span>
            </a-table>
            <!-- 分页 -->
            <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
                :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
                @showSizeChange="onShowSizeChange" @change="changeSize" />
        </a-card>
    </page-header-wrapper>
</template>
  
<script>
import { pitPositionList} from '@/api/video/video'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
    name: 'Share',
    components: {
        CreateForm
    },
    mixins: [tableMixin],
    data() {
        return {
            list: [],
            selectedRowKeys: [],
            selectedRows: [],
            // 高级搜索 展开/关闭
            advanced: false,
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            ids: [],
            loading: false,
            total: 0,
            // 查询参数
            queryParam: {
                type: null,
                channel: null,
                pageNum: 1,
                pageSize: 10
            },
            columns: [
                {
                    title: 'id',
                    dataIndex: 'id',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '语言',
                    dataIndex: 'language',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '类型',
                    dataIndex: 'type',
                    ellipsis: true,
                    align: 'center',
                    customRender: function (type) {
                        if (type == 1) {
                            return '为你推荐'
                        } else if (type == 2) {
                            return '瀑布流'
                        }
                    }
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    scopedSlots: { customRender: 'createTime' },
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: '18%',
                    scopedSlots: { customRender: 'operation' },
                    align: 'center'
                }
            ]
        }
    },
    filters: {
    },
    created() {
        this.getList()
    },
    computed: {
    },
    watch: {
    },
    methods: {
        getList() {
            this.loading = true
            pitPositionList(this.queryParam).then(response => {
                this.list = response.data
                this.total = this.list.length
                this.loading = false
            })
        },

        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParam.pageNum = 1
            this.getList()
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParam = {
                type: undefined,
                language: undefined,
                pageNum: 1,
                pageSize: 10
            }
            this.handleQuery()
        },
        onShowSizeChange(current, pageSize) {
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        changeSize(current, pageSize) {
            this.queryParam.pageNum = current
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
            this.ids = this.selectedRows.map(item => item.id)
            this.single = selectedRowKeys.length !== 1
            this.multiple = !selectedRowKeys.length
        },
        toggleAdvanced() {
            this.advanced = !this.advanced
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            var that = this
            const ids = row.id || this.ids
            if (row.id) {
                this.ids.push(row.id)
            }
            this.$confirm({
                title: '确认删除所选中数据?',
                content: '当前选中编号为' + ids + '的数据',
                onOk() {
                    const data = []
                    that.ids.map(id => data.push({ 'id': id }))
                    return delShare(data)
                        .then(() => {
                            that.onSelectChange([], [])
                            that.getList()
                            that.$message.success(
                                '删除成功',
                                3
                            )
                        })
                },
                onCancel() {
                    // 取消清空删除ids列表
                    that.ids = []
                }
            })
        },
    }
}
</script>
  